
export const createTimestamp = (date: Date) => {
  const timestamp = `${date.toISOString().split('T')[0]}.${date
    .toISOString()
    .split('T')[1]
    .split('.')[0]
    .replace(/\:/g, '-')}`
  return timestamp
}